module.exports = __webpack_public_path__ + "static/media/image-2.0c3108fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EstablishingAVoiceForYourBrand/image-2.png
// module id = 406
// module chunks = 0